import React, { ElementType, forwardRef } from "react";
import * as AvatarRU from "@radix-ui/react-avatar";
import styles from "./avatar.module.scss";
import classNames from "classnames";

type AvatarSize = "xs" | "sm" | "md" | "lg" | "xl" | "2xl" | "3xl" | "4xl";

export const Avatar = forwardRef((props: Props, ref: any) => {
  const {
    imageUrl,
    size = "md",
    placeholderIcon,
    text,
    addon,
    ...rest
  } = props;
  const PlaceholderIcon: any = placeholderIcon;

  return (
    <AvatarRU.Root
      {...rest}
      ref={ref}
      className={classNames(styles.base, styles[`size-${size}`])}
    >
      {imageUrl && <AvatarRU.Image src={imageUrl} className={styles.image} />}
      <AvatarRU.Fallback asChild>
        {placeholderIcon !== undefined ? (
          <PlaceholderIcon />
        ) : (
          <label>{text}</label>
        )}
      </AvatarRU.Fallback>
      {/* {addon && <div className={styles.addonPosition}>{addon}</div>} */}
    </AvatarRU.Root>
  );
});

Avatar.displayName = "Avatar";

interface Props extends React.ComponentPropsWithoutRef<"span"> {
  imageUrl?: string;
  size?: AvatarSize;
  placeholderIcon?: ElementType;
  text?: string;
  addon?: JSX.Element;
}
